import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoriesService } from '../../../services/categories/categories.service'

@Component({
  selector: 'app-delete-category-modal',
  templateUrl: './delete-category-modal.component.html',
  styleUrls: ['./delete-category-modal.component.scss']
})
export class DeleteCategoryModalComponent implements OnInit {
  @Input() typeId;
  constructor(
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private CategoriesService: CategoriesService
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.modalService.dismissAll();
  }

  delete() {
    this.SpinnerService.show();
    this.CategoriesService.delete({ id: this.typeId })
    .then((res) => {
      this.close();
      this.toastr.success('Category deleted');
      this.SpinnerService.hide();
    })
    .catch(() => {
      this.close();
      this.toastr.error('Category not deleted');
      this.SpinnerService.hide();
    });
  }

}
